import { normalizeAppLocale } from '~/utils/appLocale'

export default defineNuxtPlugin({
  name: 'app-locale',
  dependsOn: ['i18n:plugin', 'i18n:plugin:route-locale-detect'],
  async setup() {
    const { $i18n } = useNuxtApp()
    const route = useRoute()
    const i18nCookie = useCookie<string | null>('i18n_redirected', {
      sameSite: 'lax',
      secure: window.location.protocol === 'https:',
      path: '/',
    })

    const normalizedCookie = normalizeAppLocale(i18nCookie.value)
    if (i18nCookie.value && normalizedCookie && i18nCookie.value !== normalizedCookie) {
      i18nCookie.value = normalizedCookie
    }

    const pathLocale = normalizeAppLocale(route.path.match(/^\/(fr|it|de|hy|ru)(?=\/|$)/)?.[1])
    const explicit = readExplicitAppLocale()
    const next = pathLocale || explicit
    if (!next) return

    if (explicit) persistAppLocale(explicit)

    if ($i18n.locale.value !== next) {
      await $i18n.setLocale(next)
    }
  },
})
